import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import Toastr from "../../../components/common/Toastr";
import { Button, Modal } from "react-bootstrap";
import { Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import Table from "../../../components/table/ReactTable/Table";
import swal from "sweetalert";

import { attributeActions } from "../../../../_store";
import { ColumnFilter } from "../../../components/table/ReactTable/ColumnFilter";
import PageTitle from "../../../layouts/PageTitle";
import CommonService from "../../../../services/Common/CommonService";
import useFullPageLoader from "../../../../hooks/useFullPageLoader";
import {
  restApi,
  restApi_PD,
} from "../../../../services/wooCommerceRestApi/restApi";
import generatePDF from "../../../components/export/generatePDF";
import generateXlsx from "../../../components/export/generateXlsx";

const Attributes = () => {
  const dispatch = useDispatch();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const currentUser = useSelector((x) => x.auth.user);
  const attributeList = useSelector((x) => x.attribute.attributeList);
  const attribute = useSelector((x) => x.attribute.attribute);
  const attributeResponse = useSelector((x) => x.attribute.attributeResponse);
  const deleteAttributeResponse = useSelector(
    (x) => x.attribute.deleteAttributeResponse
  );
  const isLoading = useSelector((x) => x.attribute.isLoading);

  // Table Header
  const AttributeList_COLUMNS = [
    {
      Header: "Attribute Name",
      Footer: "Attribute Name",
      accessor: "AttributeName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Created Date",
      Footer: "Created Date",
      accessor: "CreatedDateString",
      fieldType: "Date",
      // Cell: ({ value }) => { return format(new Date(value), 'MM/dd/yyyy') },
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Website",
      Footer: "Website",
      accessor: "Woocommerce",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Status",
      Footer: "Status",
      accessor: "StatusName",
      justify: "center",
      Cell: ({ value }) => {
        return (
          <>
            <Badge variant="primary light badge-lg"> {value}</Badge>
          </>
        );
      },
      Filter: ColumnFilter,
    },
    {
      Header: "",
      Footer: "",
      accessor: "AttributeID",
      disableFilters: true,
      Cell: ({ row }) => {
        return (
          <>
            <div className="d-flex">
              <Link
                onClick={() => handleEditClick(row.original)}
                className="btn btn-primary shadow btn-xs sharp me-1"
                title="Edit"
              >
                <i className="fas fa-pen"></i>
              </Link>
              <Link
                onClick={() => handleDeleteClick(row.original)}
                className="btn btn-danger shadow btn-xs sharp"
                title="Delete"
              >
                <i className="fa fa-trash"></i>
              </Link>
            </div>
          </>
        );
      },
    },
  ];

  const generateColumns = [
    {
      header: " Attribute Name",
      dataKey: "AttributeName",
    },
    {
      header: "Created Date",
      dataKey: "CreatedDateString",
    },
    {
      header: "Website",
      dataKey: "Woocommerce",
    },
    {
      header: "Status",
      dataKey: "StatusName",
    },
  ];
  const columns = useMemo(() => AttributeList_COLUMNS, []);

  const [isOpenModal, setOpenModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [finalTableData, setFinalTableData] = useState([]);

  const handleTableDataUpdate = useCallback((data) => {
    setFinalTableData(data);
  }, []);

  //Add data
  const [addFormData, setAddFormData] = useState({
    AttributeID: 0,
    WCAttributeID: 0,
    PDWCAttributeID: 0,
    AttributeName: "",
    Slug: "",
    EnableArchives: true,
    Status: 1,
    IsGemar: false,
    IsPartyDeco: false,
    CreatedBy: currentUser.Id,
  });
  const newFormData = { ...addFormData };
  const [wordPressData, setWordPressData] = useState({
    source_url: "",
  });
  useEffect(() => {
    showLoader();
    dispatch(attributeActions.getAttributeAll());
  }, [dispatch]);
  useEffect(() => {
    if (isLoading) {
      hideLoader();
    }
  }, [isLoading]);

  // handle Change function
  const handleChange = (event) => {
    event.preventDefault();
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    if (fieldValue && fieldValue.trim()) {
      newFormData[fieldName] = fieldValue;
    } else {
      newFormData[fieldName] = fieldValue.trim();
    }

    setAddFormData(newFormData);
  };

  const handleChkBoxChangeWooCom = (event) => {
    const { name, checked } = event.target;

    setAddFormData((newFormData) => ({
      ...newFormData,
      [name]: checked ? true : false,
    }));
  };

  // Submit data function
  // const handleSubmit = (event) => {
  //
  //     event.preventDefault();
  //     var error = false;
  //     if (!addFormData.AttributeName) {
  //         error = true;

  //     }
  //     if (!error) {
  //         if (newFormData.AttributeID > 0) {
  //             showLoader();
  //             let data = {
  //                 name: newFormData.AttributeName,
  //                 slug: newFormData.Slug,
  //                 enableArchives: newFormData.EnableArchives
  //             };

  //             let Param = {
  //                 AttributeID: newFormData.AttributeID,
  //                 AttributeName: newFormData.AttributeName
  //             };

  //             CommonService.AttributeExistsCheck(Param).then(res => {

  //                 if (res.data === 1) {
  //                     // woocommerce API
  //                     restApi.put("products/attributes/" + newFormData.WCAttributeID, data)
  //                         .then((response) => {

  //                             console.log(response.data);
  //                             if (response.status === 200 || response.status === 201 || (!response.statusText)) {
  //                                 newFormData.WCAttributeID = response.data.id;
  //                                 newFormData.Slug = response.data.slug;
  //                                 // Core API
  //                                 dispatch(attributeActions.saveAttribute(newFormData));
  //                             } else {
  //                                 hideLoader();
  //                                 Toastr(response.statusText, 'warning');
  //                             }
  //                         })
  //                         .catch((error) => {

  //                             hideLoader();
  //                             let msg = "";
  //                             if (error.response) {
  //                                 if (error.response.data.code === "woocommerce_rest_cannot_create" || error.response.data.code === "woocommerce_rest_cannot_edit") {
  //                                     msg = "The Slug Name already exist "
  //                                 } else {
  //                                     msg = error.response.data.message;
  //                                 }
  //                             } else {
  //                                 msg = "rest Api error";
  //                             }
  //                             Toastr(msg, 'warning');
  //                             console.log();

  //                         });
  //                 }
  //                 else {
  //                     Toastr('This Attribute Name is already Exists', "warning");
  //                     hideLoader();
  //                 }
  //             });

  //         } else {
  //             if (wordPressData.source_url) {
  //                 Toastr('Please fill in the required missing fields', 'warning');
  //             } else {
  //                 showLoader();
  //                 const data = {
  //                     name: newFormData.AttributeName,
  //                     slug: newFormData.Slug,

  //                 };

  //                 let Param = { AttributeID: 0, AttributeName: newFormData.AttributeName };

  //                 CommonService.AttributeExistsCheck(Param).then(res => {

  //                     if (res.data === 1) {
  //                         // woocommerce API
  //                         restApi.post("products/attributes?id=" + newFormData.WCAttributeID, data)
  //                             .then((response) => {

  //                                 console.log(response.data);
  //                                 if (response.status === 200 || response.status === 201 || (!response.statusText)) {
  //                                     newFormData.WCAttributeID = response.data.id;
  //                                     newFormData.Slug = response.data.slug;

  //                                     // Core API
  //                                     dispatch(attributeActions.saveAttribute(newFormData));
  //                                 } else {
  //                                     hideLoader();
  //                                     Toastr(response.statusText, 'warning');
  //                                 }

  //                             })
  //                             .catch((error) => {

  //                                 hideLoader();
  //                                 let msg = "";
  //                                 if (error.response) {
  //                                     if (error.response.data.code === "woocommerce_rest_cannot_edit" || error.response.data.code === "woocommerce_rest_cannot_create") {
  //                                         msg = "The Slug Name already exist "
  //                                     } else {
  //                                         msg = error.response.data.message;
  //                                     }
  //                                 } else {
  //                                     msg = "rest Api error";
  //                                 }
  //                                 Toastr(msg, 'warning');
  //                                 console.log();

  //                             });
  //                     }
  //                     else {
  //                         Toastr('This Attribute Name is already Exists', "warning");
  //                         hideLoader();
  //                     }

  //                 });

  //             }

  //         }

  //     } else {
  //         hideLoader();
  //         setSubmitted(true);
  //         Toastr('Please fill in the required missing fields', 'warning');
  //     }
  // };

  const handleSubmit = (event) => {
    event.preventDefault();
    var error = false;
    if (
      !addFormData.AttributeName ||
      (addFormData.IsGemar === false && addFormData.IsPartyDeco === false)
    ) {
      error = true;
    }
    if (!error) {
      if (newFormData.AttributeID > 0) {
        showLoader();
        let gemar_data = {
          name: newFormData.AttributeName,
          slug: newFormData.Slug,
          enableArchives: newFormData.EnableArchives,
        };

        let PD_data = {
          name: newFormData.AttributeName,
          has_archives: newFormData.EnableArchives,
        };

        if (addFormData.IsGemar === true && addFormData.IsPartyDeco === true) {
          if (
            newFormData.WCAttributeID > 0 &&
            newFormData.PDWCAttributeID > 0
          ) {
            UpdateAttribute_GemarAndPD(gemar_data, PD_data);
          } else if (newFormData.WCAttributeID > 0) {
            UpdateAttribute_UpdateGemarAndAddPD(gemar_data, PD_data);
          } else if (newFormData.PDWCAttributeID > 0) {
            UpdateAttribute_AddGemarAndUpdatePD(gemar_data, PD_data);
          }
        } else if (addFormData.IsGemar === true) {
          UpdateAttribute_Gemar(gemar_data);
        } else if (addFormData.IsPartyDeco === true) {
          UpdateAttribute_PD(PD_data);
        }
      } else {
        let gemar_data = {
          AttributeID: newFormData.AttributeID,
          AttributeName: newFormData.AttributeName,
        };

        let PD_data = {
          AttributeID: newFormData.AttributeID,
          AttributeName: newFormData.AttributeName,
        };

        if (addFormData.IsGemar === true && addFormData.IsPartyDeco === true) {
          AddAttribute_GemarAndPD(gemar_data, PD_data);
        } else if (addFormData.IsGemar === true) {
          AddAttribute_Gemar(gemar_data);
        } else if (addFormData.IsPartyDeco === true) {
          AddAttribute_PD(PD_data);
        }
      }
    } else {
      hideLoader();
      setSubmitted(true);
      Toastr("Please fill in the required missing fields", "warning");
    }
  };

  // Migration fun
  /* const handleMigrationSubmit = (event) => {
    newFormData.WCAttributeID = 0;
    newFormData.Slug = newFormData.AttributeName;

    dispatch(attributeActions.saveAttribute(newFormData));
  }; */

  const gemar_data = {
    name: newFormData.AttributeName,
    slug: newFormData.Slug,
    enableArchives: newFormData.EnableArchives,
  };

  const PD_data = {
    name: newFormData.AttributeName,
    has_archives: newFormData.EnableArchives,
  };

  function AddAttribute_GemarAndPD() {
    showLoader();
    let Param = { AttributeID: 0, AttributeName: newFormData.AttributeName };
    CommonService.AttributeExistsCheck(Param).then((res) => {
      if (res.data === 1) {
        restApi
          .post("products/attributes", gemar_data) // Gemar API
          .then((response) => {
            console.log(response.data);
            if (
              response.status === 200 ||
              response.status === 201 ||
              !response.statusText
            ) {
              newFormData.WCAttributeID = response.data.id;
              newFormData.Slug = response.data.slug;

              restApi_PD
                .post("products/attributes", PD_data) // Party Deco API
                .then((PDResponse) => {
                  console.log(PDResponse.data);
                  if (
                    PDResponse.status === 200 ||
                    PDResponse.status === 201 ||
                    !PDResponse.statusText
                  ) {
                    newFormData.PDWCAttributeID = PDResponse.data.id;
                    dispatch(attributeActions.saveAttribute(newFormData));
                  } else {
                    hideLoader();
                    Toastr(PDResponse.statusText, "warning");
                  }
                })
                .catch((error) => {
                  hideLoader();
                  let msg = "";
                  if (error.response) {
                    if (error.response.data.code === "term_exists") {
                      msg = "Party Deco Attribute name already exists";
                    } else {
                      msg = error.response.data.message;
                    }
                  } else {
                    msg = "rest Api error";
                  }
                  Toastr(msg, "warning");
                  console.log();
                });
            } else {
              hideLoader();
              Toastr(response.statusText, "warning");
            }
          })
          .catch((error) => {
            hideLoader();
            let msg = "";
            if (error.response) {
              if (error.response.data.code === "term_exists") {
                msg = "Gemar Attribute name already exists";
              } else {
                msg = error.response.data.message;
              }
            } else {
              msg = "rest Api error";
            }
            Toastr(msg, "warning");
            console.log();
          });
      } else {
        hideLoader();
        Toastr("Attribute already exists", "warning");
      }
    });
  }

  function AddAttribute_Gemar() {
    showLoader();
    let Param = { AttributeID: 0, AttributeName: newFormData.AttributeName };

    CommonService.AttributeExistsCheck(Param).then((res) => {
      if (res.data === 1) {
        showLoader();
        restApi
          .post("products/attributes", gemar_data) // Gemar API
          .then((response) => {
            console.log(response.data);
            if (
              response.status === 200 ||
              response.status === 201 ||
              !response.statusText
            ) {
              newFormData.WCAttributeID = response.data.id;
              newFormData.PDWCAttributeID = 0;
              newFormData.Slug = response.data.slug;

              dispatch(attributeActions.saveAttribute(newFormData));
            } else {
              hideLoader();
              Toastr(response.statusText, "warning");
            }
          })
          .catch((error) => {
            hideLoader();
            let msg = "";
            if (error.response) {
              if (error.response.data.code === "term_exists") {
                msg = "Gemar Attribute name already exists";
              } else {
                msg = error.response.data.message;
              }
            } else {
              msg = "rest Api error";
            }
            Toastr(msg, "warning");
            console.log();
          });
      } else {
        hideLoader();
        Toastr("Attribute name already exists", "warning");
      }
    });
  }

  function AddAttribute_PD() {
    showLoader();
    let Param = { AttributeID: 0, AttributeName: newFormData.AttributeName };

    CommonService.AttributeExistsCheck(Param).then((res) => {
      if (res.data === 1) {
        showLoader();
        restApi_PD
          .post("products/attributes", PD_data) // PD API
          .then((PDResponse) => {
            console.log(PDResponse.data);
            if (
              PDResponse.status === 200 ||
              PDResponse.status === 201 ||
              !PDResponse.statusText
            ) {
              newFormData.PDWCAttributeID = PDResponse.data.id;
              newFormData.WCAttributeID = 0;
              newFormData.Slug = PDResponse.data.slug;

              dispatch(attributeActions.saveAttribute(newFormData));
            } else {
              hideLoader();
              Toastr(PDResponse.statusText, "warning");
            }
          })
          .catch((error) => {
            hideLoader();
            let msg = "";
            if (error.response) {
              if (error.response.data.code === "term_exists") {
                msg = "Party Decor Attribute name already exists";
              } else {
                msg = error.response.data.message;
              }
            } else {
              msg = "rest Api error";
            }
            Toastr(msg, "warning");
            console.log();
          });
      } else {
        hideLoader();
        Toastr("Attribute name already exists", "warning");
      }
    });
  }

  function UpdateAttribute_GemarAndPD() {
    showLoader();
    let Param = {
      AttributeID: newFormData.AttributeID,
      AttributeName: newFormData.AttributeName,
    };
    CommonService.AttributeExistsCheck(Param).then((res) => {
      if (res.data === 1) {
        showLoader();

        restApi
          .put("products/attributes/" + newFormData.WCAttributeID, gemar_data) // Gemar API
          .then((response) => {
            console.log(response.data);
            if (
              response.status === 200 ||
              response.status === 201 ||
              !response.statusText
            ) {
              newFormData.WCAttributeID = response.data.id;
              newFormData.Slug = response.data.slug;

              restApi_PD
                .put(
                  "products/attributes/" + newFormData.PDWCAttributeID,
                  PD_data
                ) // Party Deco API
                .then((PDResponse) => {
                  console.log(PDResponse.data);
                  if (
                    PDResponse.status === 200 ||
                    PDResponse.status === 201 ||
                    !PDResponse.statusText
                  ) {
                    newFormData.PDWCAttributeID = PDResponse.data.id;
                    // newFormData.Slug = PDResponse.data.slug;

                    dispatch(attributeActions.saveAttribute(newFormData));
                  } else {
                    hideLoader();
                    Toastr(PDResponse.statusText, "warning");
                  }
                })
                .catch((error) => {
                  hideLoader();
                  let msg = "";
                  if (error.response) {
                    if (error.response.data.code === "term_exists") {
                      msg = "Party Deco Attribute name already exists";
                    } else {
                      msg = error.response.data.message;
                    }
                  } else {
                    msg = "rest Api error";
                  }
                  Toastr(msg, "warning");
                  console.log();
                });
            } else {
              hideLoader();
              Toastr(response.statusText, "warning");
            }
          })
          .catch((error) => {
            hideLoader();
            let msg = "";
            if (error.response) {
              if (error.response.data.code === "term_exists") {
                msg = "Gemar Attribute name already exists";
              } else {
                msg = error.response.data.message;
              }
            } else {
              msg = "rest Api error";
            }
            Toastr(msg, "warning");
            console.log();
          });
      } else {
        hideLoader();
        Toastr("Attribute already exists", "warning");
      }
    });
  }

  function UpdateAttribute_UpdateGemarAndAddPD() {
    showLoader();
    let Param = {
      AttributeID: newFormData.AttributeID,
      AttributeName: newFormData.AttributeName,
    };
    CommonService.AttributeExistsCheck(Param).then((res) => {
      if (res.data === 1) {
        showLoader();

        restApi
          .put("products/attributes/" + newFormData.WCAttributeID, gemar_data) // Gemar API
          .then((response) => {
            console.log(response.data);
            if (
              response.status === 200 ||
              response.status === 201 ||
              !response.statusText
            ) {
              newFormData.WCAttributeID = response.data.id;
              newFormData.Slug = response.data.slug;
              // Add PD
              restApi_PD
                .post("products/attributes", PD_data) // PD API
                .then((PDResponse) => {
                  console.log(PDResponse.data);
                  if (
                    PDResponse.status === 200 ||
                    PDResponse.status === 201 ||
                    !PDResponse.statusText
                  ) {
                    newFormData.PDWCAttributeID = PDResponse.data.id;
                    newFormData.Slug = PDResponse.data.slug;

                    dispatch(attributeActions.saveAttribute(newFormData));
                  } else {
                    hideLoader();
                    Toastr(PDResponse.statusText, "warning");
                  }
                })
                .catch((error) => {
                  hideLoader();
                  let msg = "";
                  if (error.response) {
                    if (error.response.data.code === "term_exists") {
                      msg = "Party Decor Attribute name already exists";
                    } else {
                      msg = error.response.data.message;
                    }
                  } else {
                    msg = "rest Api error";
                  }
                  Toastr(msg, "warning");
                  console.log();
                });
            } else {
              hideLoader();
              Toastr(response.statusText, "warning");
            }
          })
          .catch((error) => {
            hideLoader();
            let msg = "";
            if (error.response) {
              if (error.response.data.code === "term_exists") {
                msg = "Gemar Attribute name already exists";
              } else {
                msg = error.response.data.message;
              }
            } else {
              msg = "rest Api error";
            }
            Toastr(msg, "warning");
            console.log();
          });
      } else {
        hideLoader();
        Toastr("Attribute already exists", "warning");
      }
    });
  }

  function UpdateAttribute_AddGemarAndUpdatePD() {
    showLoader();
    let Param = {
      AttributeID: newFormData.AttributeID,
      AttributeName: newFormData.AttributeName,
    };

    CommonService.AttributeExistsCheck(Param).then((res) => {
      if (res.data === 1) {
        showLoader();

        restApi_PD
          .put("products/attributes/" + newFormData.PDWCAttributeID, PD_data) // Gemar API
          .then((PDResponse) => {
            console.log(PDResponse.data);
            if (
              PDResponse.status === 200 ||
              PDResponse.status === 201 ||
              !PDResponse.statusText
            ) {
              newFormData.PDWCAttributeID = PDResponse.data.id;
              newFormData.Slug = PDResponse.data.slug;

              restApi
                .post("products/attributes", gemar_data) // Gemar API
                .then((response) => {
                  console.log(response.data);
                  if (
                    response.status === 200 ||
                    response.status === 201 ||
                    !response.statusText
                  ) {
                    newFormData.WCAttributeID = response.data.id;
                    newFormData.Slug = response.data.slug;

                    dispatch(attributeActions.saveAttribute(newFormData));
                  } else {
                    hideLoader();
                    Toastr(response.statusText, "warning");
                  }
                })
                .catch((error) => {
                  hideLoader();
                  let msg = "";
                  if (error.response) {
                    if (error.response.data.code === "term_exists") {
                      msg = "Gemar Attribute name already exists";
                    } else {
                      msg = error.response.data.message;
                    }
                  } else {
                    msg = "rest Api error";
                  }
                  Toastr(msg, "warning");
                  console.log();
                });
            } else {
              hideLoader();
              Toastr(PDResponse.statusText, "warning");
            }
          })
          .catch((error) => {
            hideLoader();
            let msg = "";
            if (error.response) {
              if (error.response.data.code === "term_exists") {
                msg = "Party Decor Attribute name already exists";
              } else {
                msg = error.response.data.message;
              }
            } else {
              msg = "Party decor rest Api error";
            }
            Toastr(msg, "warning");
            console.log();
          });
      } else {
        hideLoader();
        Toastr("Attribute name already exists", "warning");
      }
    });
  }

  function UpdateAttribute_Gemar() {
    showLoader();
    let Param = {
      AttributeID: newFormData.AttributeID,
      AttributeName: newFormData.AttributeName,
    };

    CommonService.AttributeExistsCheck(Param).then((res) => {
      if (res.data === 1) {
        showLoader();

        restApi
          .put("products/attributes/" + newFormData.WCAttributeID, gemar_data) // Gemar API
          .then((response) => {
            console.log(response.data);
            if (
              response.status === 200 ||
              response.status === 201 ||
              !response.statusText
            ) {
              newFormData.WCAttributeID = response.data.id;
              newFormData.Slug = response.data.slug;

              // Core WMS API
              dispatch(attributeActions.saveAttribute(newFormData));
            } else {
              hideLoader();
              Toastr(response.statusText, "warning");
            }
          })
          .catch((error) => {
            hideLoader();
            let msg = "";
            if (error.response) {
              if (error.response.data.code === "term_exists") {
                msg = "Gemar Attribute name already exists";
              } else {
                msg = error.response.data.message;
              }
            } else {
              msg = "rest Api error";
            }
            Toastr(msg, "warning");
            console.log();
          });
      } else {
        hideLoader();
        Toastr("Attribute name already exists", "warning");
      }
    });
  }

  function UpdateAttribute_PD() {
    showLoader();
    let Param = {
      AttributeID: newFormData.AttributeID,
      AttributeName: newFormData.AttributeName,
    };

    CommonService.AttributeExistsCheck(Param).then((res) => {
      if (res.data === 1) {
        showLoader();

        restApi_PD
          .put("products/attributes/" + newFormData.PDWCAttributeID, PD_data) // Gemar API
          .then((PDResponse) => {
            console.log(PDResponse.data);
            if (
              PDResponse.status === 200 ||
              PDResponse.status === 201 ||
              !PDResponse.statusText
            ) {
              newFormData.PDWCAttributeID = PDResponse.data.id;
              newFormData.Slug = PDResponse.data.slug;

              // Core WMS API
              dispatch(attributeActions.saveAttribute(newFormData));
            } else {
              hideLoader();
              Toastr(PDResponse.statusText, "warning");
            }
          })
          .catch((error) => {
            hideLoader();
            let msg = "";
            if (error.response) {
              if (error.response.data.code === "term_exists") {
                msg = "Party Decor Attribute name already exists";
              } else {
                msg = error.response.data.message;
              }
            } else {
              msg = "Party decor rest Api error";
            }
            Toastr(msg, "warning");
            console.log();
          });
      } else {
        hideLoader();
        Toastr("Attribute name already exists", "warning");
      }
    });
  }

  // Attribute Add And Update  handleSubmit //
  useEffect(() => {
    if (attributeResponse === 1) {
      hideLoader();
      Toastr("Attribute Successfully Added", "success");
      dispatch(attributeActions.getAttributeAll());
      setOpenModal(false);
    } else if (attributeResponse === 2) {
      hideLoader();
      Toastr("Attribute Successfully Updated", "success");
      dispatch(attributeActions.getAttributeAll());
      setOpenModal(false);
    } else if (attributeResponse === -1) {
      hideLoader();
      Toastr("The Slug Name already exist ", "warning");
    }
  }, [attributeResponse]);
  const handleEditClick = (values) => {
    let newWordPressData = { ...wordPressData };
    newWordPressData.source_url = "";
    setWordPressData(newWordPressData);
    dispatch(
      attributeActions.getAttributeById({ AttributeID: values.AttributeID })
    );
    setOpenModal(true);
    setSubmitted(false);
  };

  // handle Check Box Click function
  const handleCkBoxChange = (event, title) => {
    let hasChecked = event.target.checked === true ? 1 : 2;
    if (
      !event.target.checked &&
      newFormData.AttributeID &&
      newFormData.AttributeID > 0
    ) {
      showLoader();

      let Param = { DeleteID: newFormData.AttributeID, DeleteType: 2 };
      CommonService.CheckMappedItem(Param).then((res) => {
        if (res.data === 1) {
          newFormData[title] = hasChecked;
          setAddFormData(newFormData);
          hideLoader();
        } else {
          Toastr(" This Attribute is already mapped with the Terms", "warning");
          hideLoader();
        }
      });
    } else {
      newFormData[title] = hasChecked;
      setAddFormData(newFormData);
    }
  };

  const handlePoupClick = () => {
    newFormData.AttributeID = newFormData.WCAttributeID = 0;
    newFormData.AttributeName = newFormData.Slug = "";
    newFormData.Status = 1;
    newFormData.IsGemar = newFormData.IsPartyDeco = false;
    setAddFormData(newFormData);
    setOpenModal(true);
    setSubmitted(false);
    let newWordPressData = { ...wordPressData };
    newWordPressData.source_url = "";
    setWordPressData(newWordPressData);
  };
  // Edit attribute
  useEffect(() => {
    if (attribute && attribute.AttributeID > 0) {
      newFormData.WCAttributeID = attribute.WCAttributeID;
      newFormData.AttributeID = attribute.AttributeID;
      newFormData.AttributeName = attribute.AttributeName;
      newFormData.Slug = attribute.Slug;
      newFormData.EnableArchives = attribute.EnableArchives;
      newFormData.PDWCAttributeID = attribute.PDWCAttributeID;
      newFormData.IsGemar = attribute.IsGemar;
      newFormData.IsPartyDeco = attribute.IsPartyDeco;
      newFormData.Status = attribute.Status;
      setAddFormData(newFormData);
    }
  }, [attribute]);

  const handleDeleteClick = (values) => {
    swal({
      title: "Are you sure, you want to delete this Attribute?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoader();

        let Param = { DeleteID: values.AttributeID, DeleteType: 2 };
        CommonService.CheckMappedItem(Param).then((res) => {
          if (res.data === 1) {
            if (values.IsGemar === true && values.IsPartyDeco === true) {
              restApi
                .delete("products/attributes/" + values.WCAttributeID, {
                  // Gemar API
                  force: true,
                })
                .then((response) => {
                  console.log(response.data);
                  if (
                    response.status === 200 ||
                    response.status === 201 ||
                    !response.statusText
                  ) {
                    // Party Deco API
                    restApi_PD
                      .delete("products/attributes/" + values.PDWCAttributeID, {
                        force: true,
                      })
                      .then((PDResponse) => {
                        if (
                          PDResponse.status === 200 ||
                          PDResponse.status === 201 ||
                          !PDResponse.statusText
                        ) {
                          // Core API
                          dispatch(
                            attributeActions.deleteAttribute({
                              AttributeID: values.AttributeID,
                              DeletedBy: currentUser.Id,
                            })
                          );
                        } else {
                          Toastr(
                            "Party Deco : " + response.statusText,
                            "warning"
                          );
                          hideLoader();
                        }
                      })
                      .catch((error) => {
                        hideLoader();
                        Toastr(
                          error.response
                            ? error.response.data.message
                            : "rest Api error",
                          "warning"
                        );
                        console.log(error.response && error.response.data);
                      });
                  } else {
                    Toastr("Gemar : " + response.statusText, "warning");
                    hideLoader();
                  }
                })
                .catch((error) => {
                  hideLoader();
                  Toastr(
                    error.response
                      ? error.response.data.message
                      : "rest Api error",
                    "warning"
                  );
                  console.log(error.response && error.response.data);
                });
            } else if (values.IsGemar === true) {
              // Gemar API
              restApi
                .delete("products/attributes/" + values.WCAttributeID, {
                  force: true,
                })
                .then((response) => {
                  console.log(response.data);
                  if (
                    response.status === 200 ||
                    response.status === 201 ||
                    !response.statusText
                  ) {
                    // Core API
                    dispatch(
                      attributeActions.deleteAttribute({
                        AttributeID: values.AttributeID,
                        DeletedBy: currentUser.Id,
                      })
                    );
                  } else {
                    Toastr(response.statusText, "warning");
                    hideLoader();
                  }
                })
                .catch((error) => {
                  hideLoader();
                  Toastr(
                    error.response
                      ? error.response.data.message
                      : "rest Api error",
                    "warning"
                  );
                  console.log(error.response && error.response.data);
                });
            } else if (values.IsPartyDeco === true) {
              // Party Deco API
              restApi_PD
                .delete("products/attributes/" + values.PDWCAttributeID, {
                  force: true,
                })
                .then((response) => {
                  console.log(response.data);
                  if (
                    response.status === 200 ||
                    response.status === 201 ||
                    !response.statusText
                  ) {
                    // Core API
                    dispatch(
                      attributeActions.deleteAttribute({
                        AttributeID: values.AttributeID,
                        DeletedBy: currentUser.Id,
                      })
                    );
                  } else {
                    Toastr(response.statusText, "warning");
                    hideLoader();
                  }
                })
                .catch((error) => {
                  hideLoader();
                  Toastr(
                    error.response
                      ? error.response.data.message
                      : "rest Api error",
                    "warning"
                  );
                  console.log(error.response && error.response.data);
                });
            }
          } else {
            Toastr("This Attribute is already mapped", "warning");
            hideLoader();
          }
        });
      }
    });
  };

  // handleDeleteClick
  useEffect(() => {
    if (deleteAttributeResponse === 1) {
      hideLoader();
      Toastr("Successfully Deleted", "success");
      dispatch(attributeActions.getAttributeAll());
    } else if (deleteAttributeResponse === -1) {
      hideLoader();
      Toastr("Error ", "warning");
    } else {
      // hideLoader();
    }
  }, [deleteAttributeResponse]);

  const handleClickPDF = () => {
    let title = "Attribute List";
    const columnStyles = {
      AttributeName: { halign: "left", cellWidth: 120 },
      CreatedDateString: { halign: "left", cellWidth: 30 },
      Woocommerce: { halign: "left", cellWidth: 30 },
      StatusName: { halign: "center", cellWidth: 30 },
    };

    generatePDF(finalTableData, generateColumns, true, title, columnStyles);
  };

  const handleClickExcel = () => {
    let title = "Attribute";
    let generateExcelColumns = [
      "Attribute Name",
      "Created Date",
      "Website",
      "Status",
    ];
    let new_attributeList =
      finalTableData &&
      finalTableData.map(function (obj) {
        return {
          AttributeName: obj.AttributeName,
          Slug: obj.CreatedDateString,
          StatusName: obj.StatusName,
          Woocommerce: obj.Woocommerce,
        };
      });

    generateXlsx(new_attributeList, generateExcelColumns, title);
  };

  return (
    <>
      <PageTitle activeMenu="Attributes" motherMenu="Master" />
      <ToastContainer />
      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">Attributes List</h4>
          <div className="float-sm-end">
            {attributeList && attributeList.length > 0 && (
              <>
                <Button
                  className="me-2"
                  variant="danger btn-rounded"
                  onClick={handleClickPDF}
                >
                  <span className="btn-icon-start text-danger">
                    <i className="fa fa-solid fa-file-pdf"></i>
                    {/* <i className="fa fa-regular fa-file-excel"></i> */}
                  </span>
                  PDF
                </Button>
                <Button
                  className="me-2"
                  variant="secondary btn-rounded"
                  onClick={handleClickExcel}
                >
                  <span className="btn-icon-start text-secondary">
                    {/* <i className="fa fa-solid fa-file-pdf"></i> */}
                    <i className="fa fa-regular fa-file-excel"></i>
                  </span>
                  Excel
                </Button>
              </>
            )}
            <Button
              className="me-2"
              variant="primary btn-rounded"
              onClick={handlePoupClick}
            >
              <span className="btn-icon-start text-primary">
                <i className="fa fa-plus color-info" />
              </span>
              Add
            </Button>
          </div>
        </div>
        <div className="card-body">
          <Table
            columns={columns}
            data={attributeList}
            onDataUpdate={handleTableDataUpdate}
          />
        </div>
      </div>
      {/* <!-- Modal --> */}
      <Modal className="fade bd-example-modal-lg" show={isOpenModal} size="lg">
        <Modal.Header>
          <Modal.Title>
            {newFormData.AttributeID > 0 ? "Edit Attribute" : "Add Attribute"}
          </Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => setOpenModal(false)}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">
                  Attribute Name <span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control ${
                      submitted && !addFormData.AttributeName && "border-danger"
                    }`}
                    autocomplete="off"
                    name="AttributeName"
                    required="required"
                    onChange={handleChange}
                    value={newFormData.AttributeName}
                    placeholder="Attribute Name"
                    maxLength={25}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500"></label>
                {newFormData.AttributeID > 0 ? (
                  // Update
                  <div className="contact-name">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckGemar"
                      name="IsGemar"
                      checked={addFormData.IsGemar === true}
                      disabled={
                        newFormData.AttributeID > 0 &&
                        newFormData.WCAttributeID > 0
                      }
                      onChange={(event) => handleChkBoxChangeWooCom(event)}
                    />
                    <label
                      className="form-check-label font-w600"
                      htmlFor="flexSwitchCheckGemar"
                    >
                      Gemar
                    </label>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckPartyDeco"
                        name="IsPartyDeco"
                        checked={addFormData.IsPartyDeco === true}
                        onChange={(event) => handleChkBoxChangeWooCom(event)}
                        disabled={
                          newFormData.AttributeID > 0 &&
                          newFormData.PDWCAttributeID > 0
                        }
                      />
                      <label
                        className="form-check-label font-w600"
                        htmlFor="flexSwitchCheckPartyDeco"
                      >
                        PartyDeco
                      </label>
                    </div>
                  </div>
                ) : (
                  // Add
                  <div className="contact-name">
                    <input
                      className={`form-check-input ${
                        submitted &&
                        addFormData.IsGemar === false &&
                        addFormData.IsPartyDeco === false &&
                        "border-danger"
                      }`}
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckGemar"
                      name="IsGemar"
                      checked={addFormData.IsGemar === true}
                      onChange={(event) => handleChkBoxChangeWooCom(event)}
                    />
                    <label
                      className="form-check-label font-w600"
                      htmlFor="flexSwitchCheckGemar"
                    >
                      Gemar
                    </label>
                    <div className="form-check">
                      <input
                        className={`form-check-input ${
                          submitted &&
                          addFormData.IsGemar === false &&
                          addFormData.IsPartyDeco === false &&
                          "border-danger"
                        }`}
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckPartyDeco"
                        name="IsPartyDeco"
                        checked={addFormData.IsPartyDeco === true}
                        onChange={(event) => handleChkBoxChangeWooCom(event)}
                      />
                      <label
                        className="form-check-label font-w600"
                        htmlFor="flexSwitchCheckPartyDeco"
                      >
                        PartyDeco
                      </label>
                    </div>
                  </div>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">Active</label>
                <div>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckDefault"
                      name="Status"
                      checked={newFormData.Status === 1 ? true : false}
                      onChange={(event) => handleCkBoxChange(event, "Status")}
                    />
                  </div>
                </div>
              </div>
              {/* <div className="col-md-6 mb-3">
                                <label className="text-black font-w500">Slug</label>
                                <div className="contact-name">
                                    <input type="text" className={"form-control"} autocomplete="off"
                                        name="Slug" required="required"
                                        onChange={handleChange}
                                        value={newFormData.Slug}
                                        placeholder="Slug"
                                        maxLength={28}

                                    />
                                    <span className="validation-text"></span>
                                </div>
                            </div> */}
            </div>

            <div className="row">
              {/* <div className="col-md-6 mb-3">
                                <label className="text-black font-w500" >Enable Archives</label>
                                <div >
                                    <div className="form-check form-switch">
                                        <input className="form-check-input"
                                            type="checkbox"
                                            role="switch"
                                            id="flexSwitchCheckDefault"
                                            defaultChecked
                                        />
                                    </div>
                                </div>

                            </div> */}
            </div>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger light" onClick={() => setOpenModal(false)}>
            Close
          </Button>
          <Button
            variant=""
            onClick={handleSubmit}
            //  onClick={handleMigrationSubmit}
            className="btn btn-primary"
          >
            {newFormData.AttributeID > 0 ? "Update" : "Add"}
          </Button>
        </Modal.Footer>
      </Modal>
      {loader}
    </>
  );
};

export default Attributes;
